import { IntegrationIconProps } from './types';

const Shopify = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1877 11.6393C13.1729 11.6393 13.1442 11.6393 13.1294 11.6393C12.8831 11.6093 12.6803 11.3836 12.6803 11.1279C12.6655 10.8871 12.5349 5.26072 15.7088 3.98204C16.506 3.66609 17.2459 3.72623 17.869 4.19268C18.6365 4.74929 19.1874 5.8625 19.5207 7.48725C19.7522 8.63058 19.7957 9.62342 19.7957 9.6686C19.8106 9.90926 19.6226 10.0899 19.3754 10.0447C19.1291 10.0146 18.9263 9.78898 18.9263 9.54823C18.8828 8.52527 18.5495 5.71211 17.4487 4.89969C17.1005 4.64397 16.6653 4.61385 16.144 4.82449C13.4191 5.92264 13.5497 11.2031 13.5497 11.2632C13.5497 11.4739 13.4053 11.6393 13.1877 11.6393Z"
      fill="#595961"
    />
    <path
      opacity="0.46"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7089 4.22271C17.1293 3.80144 16.4488 3.7413 15.709 4.02713C14.4192 4.55362 13.5064 5.93771 13.0573 8.04387C12.724 9.59331 12.7675 10.9925 12.7675 11.0526C12.7675 11.1278 12.7962 11.2031 12.8545 11.2632C12.9119 11.3234 12.9703 11.3686 13.0425 11.3686C13.0573 11.3686 13.0721 11.3686 13.086 11.3686C13.2165 11.3686 13.3184 11.2632 13.3184 11.1278C13.3184 11.0677 13.1879 5.69696 15.985 4.56868C16.5498 4.34309 17.0423 4.3731 17.4488 4.674C18.6219 5.5315 18.97 8.43502 19.0135 9.47304C19.0135 9.62343 19.1441 9.77393 19.3033 9.78889C19.4487 9.80395 19.5644 9.69863 19.5644 9.54823C19.5496 9.36772 19.3904 5.4563 17.7089 4.22271Z"
      fill="#B2B2C2"
    />
    <path
      opacity="0.46"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0582 11.188C13.0433 11.188 13.0433 11.188 13.0295 11.188C12.9424 11.173 12.8692 11.0827 12.8554 10.9924C12.8554 10.9322 12.8119 9.56327 13.1452 8.01372C13.5794 5.95275 14.4933 4.58371 15.7534 4.07219C16.4635 3.78635 17.1015 3.84659 17.6524 4.23774C19.2755 5.42616 19.4348 9.27743 19.4348 9.44289C19.4348 9.53315 19.3625 9.59329 19.2755 9.57833C19.1885 9.56327 19.1162 9.48807 19.1014 9.38275C19.1014 9.33757 18.9422 5.56159 17.4783 4.4784C17.0431 4.16254 16.5071 4.11737 15.8988 4.35802C13.0582 5.54653 13.1887 10.9924 13.1887 11.0526C13.2026 11.1278 13.1452 11.188 13.0582 11.188Z"
      fill="#B2B2C2"
    />
    <path
      opacity="0.62"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2322 6.88555C14.348 6.65995 14.4637 6.43426 14.5655 6.1936C14.522 6.2688 14.2322 7.05111 13.348 6.93073C13.3331 6.93073 13.8692 7.09618 14.2322 6.88555Z"
      fill="#595961"
    />
    <path
      opacity="0.62"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9124 7.84821C13.9994 7.60746 14.0865 7.35174 14.1448 7.11108C14.1161 7.20134 13.9707 8.01367 13.043 8.01367C13.043 8.01367 13.5791 8.11898 13.9124 7.84821Z"
      fill="#595961"
    />
    <path
      opacity="0.62"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0001 5.90771C18.8844 5.63684 18.7538 5.38113 18.6232 5.11035C18.6667 5.20061 19.1019 6.05811 18.6094 6.67486C18.6094 6.67486 18.9862 6.37406 19.0001 5.90771Z"
      fill="#595961"
    />
    <path
      opacity="0.62"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.2042 4.55376C17.9717 4.35818 17.7402 4.17766 17.5078 4.01221C17.5949 4.08741 18.3633 4.64402 18.3198 5.48656C18.305 5.48656 18.4356 4.99009 18.2042 4.55376Z"
      fill="#595961"
    />
    <path
      opacity="0.62"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6531 6.05792C14.8272 5.8774 14.9716 5.68183 15.1308 5.47119C15.0735 5.53133 14.5948 6.14818 13.7402 5.92248C13.7402 5.92248 14.2328 6.19335 14.6531 6.05792Z"
      fill="#595961"
    />
    <path
      opacity="0.62"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1883 5.36601C15.391 5.21561 15.579 5.06512 15.7679 4.89966C15.6957 4.94484 15.1013 5.44121 14.2754 5.08017C14.2754 5.08017 14.7531 5.42615 15.1883 5.36601Z"
      fill="#595961"
    />
    <path
      opacity="0.62"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.9716 4.86936C16.2179 4.79416 16.4503 4.7039 16.6818 4.61365C16.5947 4.64367 15.8559 4.91444 15.1309 4.34277C15.1457 4.34277 15.5226 4.79416 15.9716 4.86936Z"
      fill="#595961"
    />
    <path
      opacity="0.62"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6807 4.59885C16.8835 4.62897 17.0862 4.64403 17.289 4.65909C17.2168 4.64403 16.5788 4.59886 16.2168 3.99707C16.2168 3.99707 16.3622 4.40328 16.6807 4.59885Z"
      fill="#595961"
    />
    <path
      opacity="0.62"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5218 4.92949C17.6662 5.09505 17.8264 5.26051 17.9995 5.41091C17.9421 5.35077 17.4496 4.8543 17.5653 4.23755C17.5505 4.23755 17.3912 4.58352 17.5218 4.92949Z"
      fill="#595961"
    />
    <path
      opacity="0.74"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2755 9.3677C19.2755 9.20214 19.1163 5.39605 17.5367 4.23775C17.2321 4.01206 16.8987 3.90674 16.5506 3.90674C16.2895 3.90674 16.0145 3.96688 15.7247 4.08725C14.4636 4.58372 13.5794 5.92264 13.1452 7.96855C12.8119 9.50304 12.8554 10.8721 12.8554 10.9322C12.8554 10.9774 12.8989 11.0225 12.9424 11.0225H12.9563C12.9998 11.0225 13.0295 10.9924 13.0295 10.9473C13.0295 10.8871 12.8841 5.39605 15.7969 4.22269C16.4348 3.96688 16.9858 4.01206 17.4497 4.35803C18.956 5.45628 19.1162 9.2925 19.1162 9.33758C19.1162 9.38276 19.1598 9.42784 19.2033 9.42784C19.2033 9.42784 19.2033 9.42784 19.2171 9.42784C19.2468 9.4429 19.2755 9.41278 19.2755 9.3677Z"
      fill="url(#paint0_linear_1334_1871)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5225 7.48736C19.1892 5.86262 18.6383 4.76436 17.8708 4.19269C17.4504 3.8919 17.0004 3.75646 16.5078 3.78658C16.8995 3.8166 17.2615 3.95204 17.5948 4.19269C18.3633 4.7494 18.9143 5.86262 19.2476 7.48736C19.479 8.6307 19.5225 9.62354 19.5225 9.66871C19.5225 9.84923 19.4355 9.98467 19.2901 10.0297C19.3197 10.0448 19.3485 10.0448 19.3633 10.0448C19.6096 10.0749 19.7975 9.90937 19.7836 9.66871C19.7975 9.62354 19.7539 8.64575 19.5225 7.48736Z"
      fill="url(#paint1_linear_1334_1871)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8698 4.82453C13.1449 5.92269 13.2754 11.2031 13.2754 11.2633C13.2754 11.4438 13.1884 11.5792 13.043 11.6243C13.0726 11.6394 13.0865 11.6394 13.1162 11.6394C13.13 11.6394 13.1597 11.6394 13.1735 11.6394C13.3911 11.6394 13.5355 11.4739 13.5355 11.2633C13.5355 11.2031 13.406 5.93775 16.1299 4.83959C16.3188 4.76439 16.4929 4.71922 16.6521 4.70416C16.4197 4.65908 16.1596 4.70416 15.8698 4.82453Z"
      fill="url(#paint2_linear_1334_1871)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.9994 6.13317L7.71012 10.0746C7.71012 10.0746 7.18888 10.2251 7.05832 10.3906C6.92776 10.556 6.89907 11.0224 6.89907 11.0224L5 26.2167L19.2605 28.9848L20.3624 6.11811C20.2031 6.08799 20.0429 6.11811 19.9994 6.13317Z"
      fill="url(#paint3_linear_1334_1871)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.2459 8.08888C24.2459 8.08888 24.231 7.9685 24.1588 7.92342C24.1005 7.87825 24.0282 7.87825 24.0282 7.87825L22.0135 7.72785L20.5358 6.20842C20.4774 6.16325 20.4191 6.13322 20.3469 6.11816L19.2461 28.9849L26.9697 27.2548L24.2459 8.08888Z"
      fill="url(#paint4_linear_1334_1871)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9277 18.8301C14.7101 18.5293 14.4499 18.2585 14.1888 18.0177C13.9277 17.7771 13.6527 17.5815 13.3768 17.401C13.1889 17.2806 13.0148 17.1602 12.8694 17.0398C12.725 16.9196 12.6092 16.7992 12.5222 16.6939C12.4352 16.5735 12.363 16.4682 12.3194 16.3479C12.2759 16.2275 12.2611 16.1071 12.2611 15.9868C12.2611 15.8213 12.3046 15.6559 12.363 15.5204C12.4203 15.3851 12.5222 15.2647 12.6231 15.1594C12.7398 15.0541 12.8694 14.9789 13.0296 14.9187C13.1888 14.8585 13.3767 14.8285 13.5795 14.8134C13.7971 14.7984 14.0147 14.8134 14.2175 14.8285C14.4202 14.8434 14.6091 14.8886 14.7971 14.9337C14.9712 14.9789 15.1452 15.039 15.2896 15.0993C15.435 15.1594 15.5794 15.2195 15.6813 15.2798L16.6378 12.3312C16.4934 12.256 16.3193 12.1807 16.1304 12.1356C15.9276 12.0754 15.71 12.0303 15.4637 12.0002C15.2174 11.9701 14.9563 11.9551 14.6813 11.9551C14.4064 11.9551 14.1166 11.9701 13.812 12.0152C13.1602 12.1055 12.5796 12.286 12.0583 12.5568C11.5658 12.8126 11.1306 13.1435 10.7686 13.5497C10.4204 13.9409 10.1454 14.3921 9.94267 14.9037C9.75375 15.4001 9.63806 15.9568 9.60937 16.5584C9.59454 16.9196 9.62321 17.2505 9.71025 17.5514C9.78245 17.8523 9.89915 18.1381 10.0584 18.4089C10.2028 18.6797 10.3917 18.9204 10.5945 19.146C10.7972 19.3717 11.0435 19.5823 11.2898 19.7779C11.4925 19.9283 11.6666 20.0787 11.812 20.2141C11.9564 20.3496 12.0732 20.4849 12.1592 20.6354C12.2463 20.7707 12.3046 20.9062 12.3481 21.0566C12.3916 21.192 12.4065 21.3424 12.3916 21.4929C12.3916 21.6433 12.3481 21.7937 12.2898 21.9141C12.2324 22.0345 12.1592 22.1548 12.0435 22.2451C11.9426 22.3354 11.8121 22.3955 11.6667 22.4256C11.5223 22.4556 11.3482 22.4707 11.1593 22.4407C10.9427 22.4106 10.725 22.3504 10.5223 22.2601C10.3195 22.1849 10.1158 22.0795 9.92788 21.9742C9.73995 21.869 9.56588 21.7486 9.42048 21.6433C9.26124 21.538 9.13066 21.4176 9.02978 21.3274L8.37695 23.5689C8.47883 23.7193 8.62327 23.8548 8.78251 23.9901C8.94274 24.1256 9.13068 24.2609 9.34828 24.3963C9.56588 24.5167 9.79732 24.637 10.0436 24.7423C10.2899 24.8476 10.5658 24.9379 10.8408 25.0132H10.8556H10.8694H10.8843H10.8991C11.4926 25.1485 12.0583 25.1786 12.5944 25.1034C13.1453 25.0281 13.6527 24.8326 14.0869 24.5318C14.5359 24.2158 14.8989 23.7945 15.1739 23.2379C15.4498 22.6813 15.6091 22.0043 15.6378 21.2371C15.6526 20.7557 15.5943 20.3345 15.4637 19.9434C15.3332 19.4921 15.1452 19.146 14.9277 18.8301Z"
      fill="url(#paint5_linear_1334_1871)"
    />
    <path
      opacity="0.226763"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.47082 23.6915C8.43719 23.6516 8.40551 23.6109 8.37682 23.5691L9.02965 21.3275C9.03855 21.3358 9.04843 21.3445 9.05832 21.3533C9.15525 21.44 9.27595 21.5478 9.42035 21.6434C9.56575 21.7487 9.73982 21.8691 9.92775 21.9744C10.1157 22.0796 10.3194 22.185 10.5221 22.2603C10.7249 22.3505 10.9425 22.4107 11.1591 22.4408C11.3481 22.4708 11.5221 22.4558 11.6665 22.4257C11.8119 22.3956 11.9425 22.3355 12.0434 22.2452C12.1591 22.1549 12.2323 22.0346 12.2897 21.9142C12.348 21.7938 12.3915 21.6434 12.3915 21.493C12.4063 21.3425 12.3915 21.1921 12.348 21.0567C12.3045 20.9063 12.2461 20.7709 12.1591 20.6355C12.077 20.4925 11.9682 20.3632 11.8327 20.2344C11.9039 20.3148 11.9642 20.3974 12.0147 20.485C12.1017 20.6205 12.1591 20.7558 12.2026 20.9063C12.2461 21.0416 12.261 21.1921 12.2461 21.3425C12.2461 21.493 12.2026 21.6434 12.1453 21.7638C12.0869 21.8842 12.0147 22.0044 11.899 22.0947C11.7971 22.185 11.6665 22.2452 11.5221 22.2752C11.3767 22.3053 11.2027 22.3204 11.0147 22.2903C10.7971 22.2603 10.5795 22.2 10.3768 22.1098C10.174 22.0346 9.97123 21.9292 9.78232 21.8239C9.5944 21.7186 9.42036 21.5983 9.27595 21.493C9.13056 21.3974 9.00988 21.2896 8.91295 21.203C8.90306 21.1941 8.89411 21.1854 8.88422 21.1771L8.23242 23.4186C8.29671 23.5143 8.37883 23.604 8.47082 23.6915ZM10.6062 19.1598C10.5518 19.1059 10.4994 19.0513 10.449 18.9957C10.2462 18.77 10.0583 18.5294 9.9129 18.2586C9.75366 17.9877 9.63792 17.7019 9.56572 17.4011C9.47868 17.1002 9.44898 16.7692 9.46382 16.4081C9.4925 15.8064 9.60925 15.2498 9.79717 14.7533C9.99993 14.2419 10.2759 13.7906 10.6231 13.3994C10.9861 12.9932 11.4202 12.6622 11.9128 12.4065C12.435 12.1357 13.0146 11.9552 13.6664 11.8649C13.9711 11.8197 14.2609 11.8047 14.5359 11.8047C14.8118 11.8047 15.0729 11.8197 15.3192 11.8499C15.5655 11.88 15.7831 11.9251 15.9858 11.9853C16.1738 12.0304 16.3478 12.1056 16.4932 12.1808L16.4705 12.2512C16.3656 12.2056 16.2509 12.1645 16.1302 12.1357C15.9275 12.0756 15.7099 12.0304 15.4636 12.0003C15.2173 11.9702 14.9562 11.9552 14.6812 11.9552C14.4063 11.9552 14.1165 11.9702 13.8119 12.0153C13.1601 12.1056 12.5795 12.2861 12.0582 12.557C11.5656 12.8127 11.1304 13.1436 10.7684 13.5498C10.4203 13.941 10.1453 14.3922 9.94254 14.9038C9.75362 15.4002 9.63793 15.9569 9.60924 16.5585C9.59441 16.9197 9.62308 17.2506 9.71012 17.5515C9.78232 17.8524 9.89902 18.1382 10.0583 18.409C10.2027 18.6798 10.3916 18.9205 10.5943 19.1461C10.5983 19.1506 10.6023 19.1553 10.6062 19.1598ZM12.5745 16.7556C12.6536 16.8451 12.7525 16.9425 12.8693 17.04C13.0147 17.1603 13.1887 17.2807 13.3767 17.4011C13.6526 17.5816 13.9276 17.7772 14.1887 18.0178C14.2648 18.0879 14.34 18.1605 14.4152 18.2357C14.2945 18.1059 14.1689 17.9832 14.0432 17.8674C13.7831 17.6267 13.5072 17.4311 13.2323 17.2506C13.0433 17.1302 12.8693 17.0099 12.7249 16.8896C12.6705 16.8447 12.621 16.7998 12.5745 16.7556Z"
      fill="black"
    />
    <path
      opacity="0.41"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5059 24.7276L22.0134 7.72792L21.9263 7.63767L22.1588 24.4868C22.1588 24.4868 20.1153 27.7062 19.8107 27.6159C19.3616 27.4806 20.6949 6.37396 20.6949 6.37396L20.5495 6.22356C20.4922 6.17838 20.419 6.14836 20.3616 6.1333L19.2746 28.6841L19.2598 29L19.6366 28.5035L22.5059 24.7276Z"
      fill="url(#paint6_linear_1334_1871)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9565 7.11119C16.7834 7.8182 16.5658 8.48013 16.4066 8.88634C16.3047 9.12709 16.4204 9.35269 16.638 9.38281C16.8704 9.41292 17.1306 9.24737 17.2176 9.00671C17.2324 8.96154 17.6231 7.98375 17.8704 6.82536V6.8103L16.9565 7.11119Z"
      fill="url(#paint7_linear_1334_1871)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.42 9.21717C10.2173 9.66846 10.0145 10.0596 9.8691 10.3304C9.73953 10.5561 9.81172 10.7967 10.0293 10.8569C10.2459 10.9322 10.5357 10.7967 10.6663 10.571C10.6811 10.541 11.1015 9.80389 11.4783 8.87109L10.42 9.21717Z"
      fill="url(#paint8_linear_1334_1871)"
    />
    <path
      opacity="0.32"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2598 28.9848L22.5059 24.7273L26.9993 27.2547L19.2598 28.9848Z"
      fill="url(#paint9_linear_1334_1871)"
    />
    <path
      opacity="0.19"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2598 28.9848L22.4772 24.7273L26.9993 27.2547L19.2598 28.9848Z"
      fill="url(#paint10_linear_1334_1871)"
    />
    <path
      opacity="0.19"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2598 28.9848L22.4772 24.7273L26.9993 27.2547L19.2598 28.9848Z"
      fill="url(#paint11_linear_1334_1871)"
    />
    <path
      opacity="0.6"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1017 17.0702C17.7831 19.432 18.9136 21.9895 19.4783 24.4717L20.3626 6.10318C20.2034 6.07316 20.0431 6.10318 19.9996 6.11824L7.71037 10.0748C7.71037 10.0748 7.59461 10.1048 7.44922 10.1651C10.5658 11.2783 13.6814 13.6703 16.1017 17.0702Z"
      fill="url(#paint12_linear_1334_1871)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.1728 7.93849C24.246 7.99872 24.246 8.08898 24.246 8.08898L26.9412 27.2397L22.5062 24.7124L22.0137 7.71289L23.9997 7.86329C24.0136 7.87835 24.1006 7.87835 24.1728 7.93849Z"
      fill="url(#paint13_linear_1334_1871)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.8551 7.98382C23.8551 7.98382 23.9422 7.98382 24.0144 8.05902C24.0866 8.11926 24.1014 8.20951 24.1014 8.20951L26.7541 27.1497L26.9569 27.2701L24.2606 8.1042C24.2606 8.1042 24.2468 8.01394 24.1884 7.9538C24.1162 7.89356 24.0144 7.89356 24.0144 7.89356L22.0293 7.74316L23.8551 7.98382Z"
      fill="url(#paint14_linear_1334_1871)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 26.2165L19.2605 28.9846L19.9568 13.3088L6.77338 13.6836L5 26.2165Z"
      fill="url(#paint15_linear_1334_1871)"
    />
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.68148 10.2938C9.55191 10.6595 9.67948 11.0436 9.96829 11.1521C10.2561 11.2605 10.5944 11.052 10.7249 10.6865C10.8545 10.3209 10.726 9.93663 10.4381 9.82826C10.1503 9.71979 9.81105 9.92826 9.68148 10.2938Z"
      fill="white"
    />
    <path
      opacity="0.89"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.6657 10.1203C9.53613 10.4859 9.66469 10.8702 9.95251 10.9785C10.2403 11.087 10.5796 10.8785 10.7092 10.513C10.8387 10.1473 10.7112 9.76304 10.4224 9.65467C10.1345 9.54621 9.79626 9.75468 9.6657 10.1203Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.0282 7.72785L20.5495 6.20842C20.4922 6.16325 20.419 6.13322 20.3616 6.11816L19.2598 28.9849L22.5207 24.7123L22.0282 7.72785Z"
      fill="url(#paint16_linear_1334_1871)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.9991 6.13348L7.70983 10.0749C7.70983 10.0749 7.18859 10.2254 7.05803 10.3909C7.0432 10.4059 7.04314 10.421 7.0293 10.436L19.4195 6.88566C19.5214 6.85554 19.7676 6.76529 19.739 7.50241L18.9853 28.955L19.2464 29.0002L20.3472 6.13348C20.2028 6.0883 20.0426 6.11842 19.9991 6.13348Z"
      fill="url(#paint17_linear_1334_1871)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.9991 6.13348L7.70983 10.0749C7.70983 10.0749 7.18859 10.2254 7.05803 10.3909C7.0432 10.4059 7.04314 10.421 7.0293 10.436L9.89861 9.60857L19.7676 6.43437C19.8112 6.41931 19.9704 6.3892 20.1297 6.41932L19.0427 28.955L19.2464 29.0002L20.3472 6.13348C20.2028 6.0883 20.0426 6.11842 19.9991 6.13348Z"
      fill="url(#paint18_linear_1334_1871)"
    />
    <path
      opacity="0.32"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.1589 25.0885L22.506 24.7124L19.2461 28.9849L19.4192 28.9397C19.4192 28.9397 22.2894 25.1036 22.5496 24.9832C22.7385 24.908 23.1589 25.0885 23.1589 25.0885Z"
      fill="url(#paint19_linear_1334_1871)"
    />
    <path
      opacity="0.57"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2598 28.9849L22.5207 24.7124C22.5059 24.7275 20.4486 27.0592 19.2598 28.9849Z"
      fill="url(#paint20_linear_1334_1871)"
    />
    <path
      opacity="0.46"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.0003 27.2547L22.5218 24.7273C22.5069 24.7273 23.0292 24.8176 27.0003 27.2547Z"
      fill="url(#paint21_linear_1334_1871)"
    />
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3069 8.79379C16.1764 9.15944 16.3049 9.54371 16.5928 9.65217C16.8816 9.76064 17.2199 9.55217 17.3494 9.18661C17.48 8.82095 17.3514 8.43669 17.0636 8.32822C16.7758 8.21985 16.4365 8.42823 16.3069 8.79379Z"
      fill="white"
    />
    <path
      opacity="0.89"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2907 8.62097C16.1611 8.98663 16.2897 9.37089 16.5776 9.47935C16.8654 9.58772 17.2046 9.37935 17.3342 9.01369C17.4637 8.64813 17.3361 8.26388 17.0483 8.15541C16.7595 8.04694 16.4212 8.25541 16.2907 8.62097Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1893 10.8571C10.1745 10.8571 10.1458 10.8571 10.1309 10.8571C9.89949 10.8271 9.74028 10.6014 9.76896 10.3457C9.79765 10.1049 10.6235 4.47849 14.015 3.19982C14.8696 2.88386 15.5946 2.944 16.1455 3.41045C16.8121 3.96706 17.1741 5.08028 17.2325 6.70502C17.276 7.84836 17.1455 8.8412 17.1455 8.88638C17.1168 9.12703 16.8992 9.30764 16.6668 9.26247C16.4353 9.23235 16.2612 9.00675 16.3047 8.766C16.4353 7.74304 16.5797 4.92988 15.6094 4.11746C15.3048 3.86174 14.8845 3.83162 14.3197 4.04226C11.4069 5.14042 10.6383 10.4209 10.6383 10.4659C10.58 10.6916 10.4069 10.8571 10.1893 10.8571Z"
      fill="#595961"
    />
    <path
      opacity="0.46"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.9704 3.44039C15.463 3.01922 14.7963 2.95908 13.9992 3.24491C12.6224 3.7714 11.4631 5.15539 10.6659 7.24649C10.0725 8.79603 9.86874 10.1951 9.86874 10.2553C9.8549 10.3305 9.8836 10.4057 9.92712 10.466C9.97064 10.5261 10.029 10.5713 10.1012 10.5713C10.115 10.5713 10.1299 10.5713 10.1447 10.5713C10.2752 10.5713 10.3909 10.466 10.4058 10.3305C10.4196 10.2704 11.1882 4.89968 14.188 3.7714C14.7963 3.54571 15.2889 3.57583 15.637 3.87672C16.6656 4.73422 16.5213 7.63764 16.3907 8.67566C16.3759 8.82615 16.4778 8.97655 16.6222 8.99161C16.7676 9.00667 16.9119 8.90135 16.9268 8.75095C16.9416 8.5854 17.449 4.67408 15.9704 3.44039Z"
      fill="#B2B2C2"
    />
    <path
      opacity="0.81"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1303 10.4058C10.1155 10.4058 10.1155 10.4058 10.1016 10.4058C10.0146 10.3907 9.95622 10.3005 9.97105 10.2102C9.98589 10.15 10.1738 8.78104 10.7683 7.23149C11.5655 5.17052 12.696 3.80149 14.0431 3.28996C14.8116 3.00413 15.4347 3.06436 15.9125 3.45552C17.3328 4.64393 16.8402 8.49521 16.8115 8.66066C16.7967 8.75092 16.7245 8.81106 16.6226 8.7961C16.5366 8.78104 16.4782 8.70584 16.4782 8.60052C16.4782 8.55535 16.9708 4.77937 15.6959 3.69617C15.319 3.41034 14.7968 3.38032 14.1598 3.62097C11.1016 4.77937 10.3044 10.2102 10.3044 10.2703C10.2896 10.3455 10.2173 10.4058 10.1303 10.4058Z"
      fill="#B2B2C2"
    />
    <path
      opacity="0.42"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.043 6.10308C12.2022 5.87748 12.3476 5.65179 12.492 5.41113C12.4346 5.48633 12.0142 6.26864 11.1448 6.14826C11.13 6.14826 11.6374 6.31371 12.043 6.10308Z"
      fill="#595961"
    />
    <path
      opacity="0.42"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5503 7.06574C11.6809 6.82499 11.8114 6.56927 11.9123 6.32861C11.8687 6.41887 11.5789 7.23119 10.666 7.23119C10.666 7.23119 11.1735 7.33651 11.5503 7.06574Z"
      fill="#595961"
    />
    <path
      opacity="0.42"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1741 8.05899C11.2898 7.80318 11.3768 7.54746 11.4639 7.29175C11.4204 7.38201 11.2611 8.20939 10.3047 8.31471C10.3047 8.29965 10.8259 8.35988 11.1741 8.05899Z"
      fill="#595961"
    />
    <path
      opacity="0.62"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9704 5.12524C16.8982 4.85437 16.826 4.59866 16.7241 4.32788C16.7528 4.41814 17.0427 5.27564 16.4492 5.89239C16.4492 5.89239 16.8834 5.59159 16.9704 5.12524Z"
      fill="#595961"
    />
    <path
      opacity="0.62"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.4062 3.77128C16.2034 3.57571 15.9996 3.39519 15.7969 3.22974C15.8701 3.30494 16.5506 3.86154 16.3626 4.70398C16.3478 4.70398 16.5654 4.20751 16.4062 3.77128Z"
      fill="#595961"
    />
    <path
      opacity="0.62"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1157 6.50936C17.1008 6.23859 17.0573 5.95276 17.0138 5.68188C17.0138 5.7872 17.1592 6.67482 16.4629 7.15623C16.4629 7.15623 16.9416 6.9456 17.1157 6.50936Z"
      fill="#595961"
    />
    <path
      opacity="0.62"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1879 7.92357C17.2028 7.6528 17.2028 7.36697 17.1879 7.09619C17.1879 7.20151 17.2027 8.08913 16.4629 8.49524C16.4629 8.48028 16.9703 8.32978 17.1879 7.92357Z"
      fill="#595961"
    />
    <path
      opacity="0.42"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8407 9.15698C10.9277 8.88621 10.9861 8.61543 11.0435 8.35962C11.0148 8.44988 10.8842 9.30738 10 9.51801C10.0148 9.51801 10.5361 9.50296 10.8407 9.15698Z"
      fill="#595961"
    />
    <path
      opacity="0.42"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5934 5.27545C12.7962 5.09493 12.985 4.89936 13.1591 4.68872C13.0859 4.74886 12.5064 5.36571 11.6953 5.14001C11.7092 5.14001 12.1582 5.41088 12.5934 5.27545Z"
      fill="#595961"
    />
    <path
      opacity="0.42"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2452 4.58378C13.4776 4.43338 13.6952 4.28289 13.9118 4.11743C13.8258 4.16261 13.1591 4.65898 12.3906 4.29795C12.3906 4.29795 12.7962 4.64392 13.2452 4.58378Z"
      fill="#595961"
    />
    <path
      opacity="0.62"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1306 4.08738C14.3917 4.01208 14.638 3.92182 14.8843 3.83157C14.7973 3.86168 14.0149 4.13246 13.377 3.56079C13.377 3.56079 13.6816 4.01208 14.1306 4.08738Z"
      fill="#595961"
    />
    <path
      opacity="0.62"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8698 3.81663C15.0736 3.84675 15.2764 3.86181 15.4791 3.87687C15.4069 3.86181 14.7838 3.81663 14.5078 3.21484C14.5226 3.21484 14.5949 3.62105 14.8698 3.81663Z"
      fill="#595961"
    />
    <path
      opacity="0.62"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6525 4.14737C15.7831 4.31282 15.9127 4.47828 16.0432 4.62878C15.9997 4.56854 15.5942 4.07217 15.7969 3.45532C15.8118 3.45532 15.5942 3.80139 15.6525 4.14737Z"
      fill="#595961"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6519 8.58537C16.6658 8.41992 17.1593 4.61382 15.7826 3.45543C15.5214 3.22983 15.203 3.12451 14.8548 3.12451C14.5937 3.12451 14.3039 3.18465 13.9993 3.30503C12.666 3.8015 11.5503 5.14041 10.7679 7.18633C10.1735 8.72081 9.98554 10.0898 9.9707 10.15C9.9707 10.1951 9.99944 10.2402 10.043 10.2402H10.0578C10.1013 10.2402 10.13 10.2101 10.13 10.165C10.1448 10.1048 10.9271 4.61382 14.0427 3.44037C14.7094 3.18465 15.2751 3.22983 15.6806 3.5758C16.9991 4.67396 16.5066 8.51018 16.4927 8.55536C16.4927 8.60044 16.5214 8.64562 16.5649 8.64562C16.5649 8.64562 16.5649 8.64562 16.5788 8.64562C16.6223 8.66067 16.6519 8.63055 16.6519 8.58537Z"
      fill="url(#paint22_linear_1334_1871)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2322 6.70489C17.1738 5.08014 16.8118 3.98189 16.1452 3.41022C15.7832 3.10943 15.348 2.97399 14.8555 3.00411C15.2323 3.03413 15.5795 3.16957 15.8703 3.41022C16.5369 3.96693 16.8989 5.08014 16.9562 6.70489C16.9997 7.84822 16.8702 8.84107 16.8702 8.88624C16.8405 9.06676 16.7248 9.2022 16.5794 9.24727C16.6091 9.26233 16.6229 9.26234 16.6526 9.26234C16.884 9.29245 17.1016 9.1269 17.1303 8.88624C17.1452 8.84107 17.2757 7.86328 17.2322 6.70489Z"
      fill="url(#paint23_linear_1334_1871)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0297 4.04213C11.1169 5.14029 10.3484 10.4207 10.3484 10.4809C10.3197 10.6614 10.203 10.7968 10.0586 10.8419C10.0873 10.857 10.1021 10.857 10.1308 10.857C10.1456 10.857 10.1743 10.857 10.1892 10.857C10.4068 10.857 10.5798 10.6915 10.6095 10.4809C10.6234 10.4207 11.377 5.15535 14.2899 4.0571C14.4936 3.9819 14.6667 3.93682 14.827 3.92176C14.6094 3.89164 14.3334 3.93682 14.0297 4.04213Z"
      fill="url(#paint24_linear_1334_1871)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1334_1871"
        x1="13.611"
        y1="3.9407"
        x2="13.1565"
        y2="10.1289"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.65" />
        <stop offset="1" stopColor="white" stopOpacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1334_1871"
        x1="16.9331"
        y1="7.48283"
        x2="20.1331"
        y2="10.2856"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01" />
        <stop offset="1" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1334_1871"
        x1="15.6492"
        y1="10.7252"
        x2="19.0363"
        y2="7.57029"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01" />
        <stop offset="1" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1334_1871"
        x1="11.338"
        y1="1.51839"
        x2="-1.81782"
        y2="16.6768"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B8D26E" />
        <stop offset="1" stopColor="#7FB525" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1334_1871"
        x1="29.3336"
        y1="5.31342"
        x2="22.1134"
        y2="5.44749"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B4E034" />
        <stop offset="1" stopColor="#60A927" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1334_1871"
        x1="7.85867"
        y1="15.421"
        x2="1.93908"
        y2="29.8364"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#CECEEB" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1334_1871"
        x1="16.345"
        y1="50.9217"
        x2="25.7204"
        y2="50.9027"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D1D1B" stopOpacity="0.5" />
        <stop offset="0.038033" stopColor="#1D1D1B" stopOpacity="0.4837" />
        <stop offset="0.4243" stopColor="#1D1D1B" stopOpacity="0.3185" />
        <stop offset="1" stopColor="#1D1D1B" stopOpacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1334_1871"
        x1="17.4352"
        y1="5.80063"
        x2="15.8798"
        y2="6.63774"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01" />
        <stop offset="1" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1334_1871"
        x1="10.9136"
        y1="8.28338"
        x2="9.82021"
        y2="9.22302"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01" />
        <stop offset="1" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_1334_1871"
        x1="21.5782"
        y1="27.2659"
        x2="21.6889"
        y2="28.7251"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01" />
        <stop offset="1" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_1334_1871"
        x1="18.9937"
        y1="25.1298"
        x2="19.2503"
        y2="28.9235"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.5" />
        <stop offset="0.0896271" stopColor="white" stopOpacity="0.4552" />
        <stop offset="1" stopColor="white" stopOpacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_1334_1871"
        x1="18.5002"
        y1="25.7198"
        x2="18.9567"
        y2="29.7724"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01" />
        <stop offset="1" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_1334_1871"
        x1="16.71"
        y1="2.40387"
        x2="5.00205"
        y2="9.17526"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.5" />
        <stop offset="1" stopColor="white" stopOpacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_1334_1871"
        x1="18.9683"
        y1="37.7935"
        x2="29.3022"
        y2="37.8143"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D1D1B" stopOpacity="0.5" />
        <stop offset="0.0896271" stopColor="#1D1D1B" stopOpacity="0.4552" />
        <stop offset="1" stopColor="#1D1D1B" stopOpacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_1334_1871"
        x1="26.3694"
        y1="7.17307"
        x2="24.9014"
        y2="7.53276"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" stopOpacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_1334_1871"
        x1="13.1985"
        y1="29.152"
        x2="13.9618"
        y2="25.4719"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D1D1B" stopOpacity="0.5" />
        <stop offset="0.0896271" stopColor="#1D1D1B" stopOpacity="0.4552" />
        <stop offset="1" stopColor="#1D1D1B" stopOpacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_1334_1871"
        x1="17.611"
        y1="50.4532"
        x2="27.02"
        y2="50.4614"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D1D1B" stopOpacity="0.5" />
        <stop offset="1" stopColor="#1D1D1B" stopOpacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_1334_1871"
        x1="9.01339"
        y1="4.80776"
        x2="4.45002"
        y2="22.3401"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.5" />
        <stop offset="1" stopColor="white" stopOpacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_1334_1871"
        x1="9.01339"
        y1="4.80776"
        x2="4.45002"
        y2="22.3401"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.5" />
        <stop offset="1" stopColor="white" stopOpacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_1334_1871"
        x1="20.0878"
        y1="23.1862"
        x2="16.4809"
        y2="28.1507"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.5" />
        <stop offset="0.0896271" stopColor="white" stopOpacity="0.4552" />
        <stop offset="1" stopColor="white" stopOpacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_1334_1871"
        x1="21.1756"
        y1="24.3276"
        x2="20.8185"
        y2="25.1281"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01" />
        <stop offset="1" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_1334_1871"
        x1="24.7185"
        y1="25.386"
        x2="24.7009"
        y2="25.6011"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01" />
        <stop offset="1" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_1334_1871"
        x1="11.7293"
        y1="2.6181"
        x2="10.17"
        y2="8.77808"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.65" />
        <stop offset="1" stopColor="white" stopOpacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_1334_1871"
        x1="15.2194"
        y1="6.17151"
        x2="17.9319"
        y2="8.92921"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01" />
        <stop offset="1" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_1334_1871"
        x1="13.4858"
        y1="10.2325"
        x2="17.2335"
        y2="6.38367"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01" />
        <stop offset="1" stopOpacity="0.4" />
      </linearGradient>
    </defs>
  </svg>
);
export default Shopify;
